import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  left: {
    textAlign: 'left',
  },
  right: {
    textAlign: 'right',
  },
  center: {
    textAlign: 'center',
  },
  small: {
    fontSize: '.8rem',
  },
  flexBasis: {
    flexBasis: 'none',
  },
}));

export default function FooterPollResultsItem(
  { userChoice, totalResultsPercent, totalResultsNumber },
) {
  const classes = useStyles();

  return (
    <>
      <Grid
        container
        spacing={4}
        justify="space-between"
        alignItems="flex-start"
      >
        {userChoice && (
          <Grid
            item
            xs={6}
            className={classes.left}
          >
            {userChoice}
          </Grid>
        )}
        <Grid
          item
          xs={userChoice ? 6 : 12}
          className={userChoice ? classes.right : classes.center}
        >
          <span>{totalResultsPercent}</span>
          <span className={classes.small}>{totalResultsNumber}</span>
        </Grid>
      </Grid>
    </>
  );
}

FooterPollResultsItem.defaultProps = {
  userChoice: '',
  totalResultsPercent: '',
  totalResultsNumber: '',
};

FooterPollResultsItem.propTypes = {
  userChoice: PropTypes.string,
  totalResultsPercent: PropTypes.string,
  totalResultsNumber: PropTypes.string,
};
